import { req } from '../../@api/request';

export default class CourtSearchService {
  static courtList = async (
    location: string,
    court: string,
    belong: string,
    date: string,
  ) => {
    let url = '';
    if (date === 'all') {
      date = '';
    }
    if (!court && !belong && !date) {
      url = `/court/search/param?location=${location}`;
    } else {
      url = `/court/search/param?court=${court}&belong=${belong}&date=${date}`;
    }
    const result = await req.get(url);
    return result.data;
  };

  static auctionList = async (
    court: string,
    belong: string,
    date: string,
    region: string,
    category: string,
    sort: string,
    limit: number,
    offset: number,
  ) => {
    const result = await req.get(
      `/court/search?court=${court}&date=${date}&belong=${belong}&region=${region}&category=${category}&sort=${sort}&limit=${limit}&offset=${offset}`,
    );
    return result.data;
  };
}
